export enum AuditPackageStatus {
  ACTIVE = "active",
  COMPLETED = "completed",
}
